/* unplugin-vue-components disabled */import { render } from "./SvgIcon.vue?vue&type=template&id=3a1788e2&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=3a1788e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1788e2"]])

export default __exports__